import React, { useState, useEffect, useCallback } from "react";

import "../styles/AgentsPage.css";

import { Agent, CreateAgentDto, UpdateAgentDto } from "../types/app.types";
import { AgentForm } from "../components/Agent/AgentForm";
import { agentApi } from "../services/api";
import { AgentList } from "../components/Agent/AgentList";

export const AgentsPage: React.FC = () => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAgents = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await agentApi.getAll();
      setAgents(data);
    } catch (err) {
      setError("Не вдалося завантажити список агентів.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  const handleAddAgent = async (dto: CreateAgentDto) => {
    try {
      const createdAgent = await agentApi.create(dto);
      setAgents((prev) => [...prev, createdAgent]);
      setError(null);
    } catch (err) {
      setError("Не вдалося додати нового агента.");
      console.error(err);
    }
  };

  const handleUpdateAgent = async (id: number, dto: UpdateAgentDto) => {
    try {
      const currentAgent = agents.find((a) => a.id === id);
      if (
        !currentAgent ||
        (dto.name === currentAgent.name && dto.color === currentAgent.color)
      ) {
        return;
      }
      await agentApi.update(id, dto);
      setAgents((prev) =>
        prev.map((agent) => (agent.id === id ? { ...agent, ...dto } : agent))
      );
    } catch (err) {
      setError("Помилка оновлення агента.");
      console.error(err);
      fetchAgents();
    }
  };

  const handleDeleteAgent = async (id: number) => {
    if (window.confirm("Ви впевнені, що хочете видалити цього агента?")) {
      try {
        await agentApi.delete(id);
        setAgents((prev) => prev.filter((agent) => agent.id !== id));
      } catch (err) {
        setError("Помилка видалення агента.");
        console.error(err);
      }
    }
  };

  if (loading) {
    return <div className="loading-spinner"></div>;
  }

  return (
    <div className="agents-container">
      <h1 className="agents-title">Управління агентами</h1>

      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => setError(null)} className="close-error-btn">
            ×
          </button>
        </div>
      )}

      <AgentForm onAddAgent={handleAddAgent} setError={setError} />
      <AgentList
        agents={agents}
        onUpdateAgent={handleUpdateAgent}
        onDeleteAgent={handleDeleteAgent}
      />
    </div>
  );
};
